import { Skeleton } from "@mui/material";

export default function SalonSkeleton() {
    return (
        [1, 2, 3, 4].map((row) => (
            <div className="slider">
                <Skeleton variant="rectangular" className="slider-skeleton rounded" />
                <Skeleton variant="text" className="col-lg-10" />
                <Skeleton variant="text" className="col-lg-3" />
                <div className="d-flex justify-content-between">
                    <Skeleton variant="text" className="col-lg-6" />
                    <Skeleton variant="text" className="col-lg-4" />
                </div>
            </div>
        ))
    )
}

